export default "__VITE_ASSET__BAuX0F0l__"